<template>
  <div>
    <v-btn
      id="registerDeviceButton"
      @click="open"
      class="bg-accent"
      size="large"
      v-show="!$store.state.map.movingMode"
      data-cy="openRegisterDevice"
      icon="mdi-map-marker-plus"
    >
    </v-btn>
  </div>
</template>

<script>
export default {
  methods: {
    open() {
      this.$emit('open')
    }
  }
}
</script>
